import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
export var ClassRepository = /*#__PURE__*/function () {
  function ClassRepository(api) {
    _classCallCheck(this, ClassRepository);

    this.api = api;
  }

  _createClass(ClassRepository, [{
    key: "list",
    value: function list(input) {
      return this.api.list(input);
    }
  }, {
    key: "create",
    value: function create(input) {
      return this.api.create(input);
    }
  }, {
    key: "get",
    value: function get(id) {
      return this.api.get(id);
    }
  }, {
    key: "listTeachers",
    value: function listTeachers(input) {
      return this.api.listTeachers(input);
    }
  }, {
    key: "listStudents",
    value: function listStudents(input) {
      return this.api.listStudents(input);
    }
  }, {
    key: "update",
    value: function update(id, input) {
      return this.api.update(id, input);
    }
  }, {
    key: "archive",
    value: function archive(id) {
      return this.api.archive(id);
    }
  }, {
    key: "activate",
    value: function activate(id) {
      return this.api.activate(id);
    }
  }, {
    key: "delete",
    value: function _delete(id) {
      return this.api["delete"](id);
    }
  }, {
    key: "removeTeacher",
    value: function removeTeacher(classId, teacherId) {
      return this.api.removeTeacher(classId, teacherId);
    }
  }, {
    key: "removeStudent",
    value: function removeStudent(classId, studentId) {
      return this.api.removeStudent(classId, studentId);
    }
  }, {
    key: "getInvitation",
    value: function getInvitation(input) {
      return this.api.getInvitation(input);
    }
  }, {
    key: "getInvitationByCode",
    value: function getInvitationByCode(classCode) {
      return this.api.getInvitationByCode(classCode);
    }
  }, {
    key: "joinAsTeacher",
    value: function joinAsTeacher(input) {
      return this.api.joinAsTeacher(input);
    }
  }, {
    key: "joinAsStudent",
    value: function joinAsStudent(input) {
      return this.api.joinAsStudent(input);
    }
  }, {
    key: "leave",
    value: function leave(id) {
      return this.api.leave(id);
    }
  }]);

  return ClassRepository;
}();